import React from "react";

export const ViewportContext = React.createContext({
    currentBreakpoint: "lg",
    navigationCollapsed: {
        enabled: false,
        toggle: () => {},
    },
});
